import { useAppDispatch, useAppSelector } from '@/store';
import { teacherDashboardSelector } from '@/store/reducers/teacher-dashboard';
import teacherDashboardThunks from '@/store/thunks/teacher-dashboard';
import { BaseGroupDetails } from '@/types/register';
import { useState } from 'react';

const useGroupDetails = () => {
  const [isSavingGroup, setIsSavingGroup] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const { groups } = useAppSelector(teacherDashboardSelector);
  const dispatch = useAppDispatch();

  const saveGroupDetails = async (groupId: string, groupDetails: BaseGroupDetails) => {
    setIsSavingGroup(true);
    try {
      await dispatch(teacherDashboardThunks.updateGroupDetails({ groupId, groupDetails })).unwrap();

      await new Promise(resolve => setTimeout(resolve, 1000));

      setIsSavingGroup(false);
    } catch (error) {
      setError('Failed to save group details');
      setIsSavingGroup(false);
    }
  };

  const createGroup = async (groupDetails: BaseGroupDetails) => {
    setIsSavingGroup(true);

    try {
      const group = await dispatch(teacherDashboardThunks.createGroup(groupDetails)).unwrap();

      await new Promise(resolve => setTimeout(resolve, 1000));

      setIsSavingGroup(false);

      return group;
    } catch (error) {
      setError('Failed to save group details');
      setIsSavingGroup(false);
    }
  };

  return {
    isSavingGroup,
    errorLoadingGroups: error,
    saveGroupDetails,
    createGroup,
    groups,
  };
};

export default useGroupDetails;
